; import React, { useState } from "react";
import {
  BufferOverflowPractice,
  CAndGDBPractice,
  DNSSetupAndPortScan,
  LinuxBasics,
  ManipulatingStacks,
  MetasploitPractice,
  WebAppSecurityAndRuby,
  X86Assembly
} from "./EthicalHackingLabs";

const tabStyle = (active, name) =>
  `px-4 py-2 rounded-lg text-sm font-semibold transition ${
    active === name
      ? "bg-blue-600 text-white"
      : "bg-gray-800 text-gray-200 hover:bg-gray-700"
  }`;

const Labs = () => {
  const [activeTab, setActiveTab] = useState("web");

  const renderTabContent = () => {
    switch (activeTab) {
      case "web":
        return (
          <ul className="space-y-2">
            <li>
              <strong>🛡️ TryHackMe:</strong> SQL Injection Lab (Web Exploitation)
            </li>
            <li>
              <strong>📚 PortSwigger:</strong> Web Security Academy Challenge
            </li>
          </ul>
        );
      case "network security":
        return (
          <ul className="space-y-2">
            <li>
              <strong>📡 Wireshark:</strong> Traffic Capture & Analysis
            </li>
            <li>
              <strong>🧪 Nmap:</strong> Port Scanning and Service Enumeration
            </li>
          </ul>
        );
      case "digital forensics":
        return (
          <ul className="space-y-2">
            <li>
              <strong>🧠 Volatility:</strong> Memory Dump Analysis
            </li>
            <li>
              <strong>🗂️ Autopsy:</strong> File System Recovery & Metadata
            </li>
          </ul>
        );
      case "ethical hacking":
        return (
          <div className="space-y-4">
            <BufferOverflowPractice />
            <CAndGDBPractice />
            <DNSSetupAndPortScan />
            <LinuxBasics />
            <ManipulatingStacks />
            <MetasploitPractice />
            <WebAppSecurityAndRuby />
            <X86Assembly />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="mt-8 p-6 bg-[#1f1f2e] text-white rounded-xl shadow-lg">
      <h2 className="text-3xl font-bold mb-4">🧪 Cybersecurity Labs</h2>

      <div className="flex gap-4 mb-6">
        {["web", "network security", "digital forensics", "ethical hacking"].map((name) => (
          <button
            key={name}
            onClick={() => setActiveTab(name)}
            className={tabStyle(activeTab, name)}
          >
            {name.charAt(0).toUpperCase() + name.slice(1)}
          </button>
        ))}
      </div>

      <div className="pl-2 border-l-4 border-blue-500">{renderTabContent()}</div>
    </div>
  );
};

export default Labs;
